const sameId = (left, right) => Number(left) === Number(right);

export const isManagerProfile = profile =>
  profile === "admin" || profile === "superadmin";

export const getUserQueueIds = user =>
  (user?.queues || []).map(queue => Number(queue.id));

export const canNotifyTicket = (ticket, user) => {
  if (!ticket || !user) return false;

  const ticketCompanyId =
    ticket.companyId ??
    ticket.whatsapp?.companyId ??
    ticket.contact?.companyId;

  if (
    ticketCompanyId !== undefined &&
    ticketCompanyId !== null &&
    !sameId(ticketCompanyId, user.companyId)
  ) {
    return false;
  }

  if (ticket.status === "pending") {
    if (user.profile === "doctor") return false;
    if (isManagerProfile(user.profile)) return true;
    if (sameId(ticket.userId, user.id)) return true;
    if (ticket.userId) return false;
    if (ticket.queueId === undefined || ticket.queueId === null) return true;

    return getUserQueueIds(user).includes(Number(ticket.queueId));
  }

  if (ticket.status === "open") {
    const isAssignedToUser = sameId(ticket.userId, user.id);
    const isSharedWithUser = (ticket.sharedWithUsers || []).some(sharedUser =>
      sameId(sharedUser.id, user.id)
    );

    return isAssignedToUser || isSharedWithUser;
  }

  return false;
};
